import React, { lazy } from 'react';

const CoSignerIdentityComponent = lazy(
  () => import(/* webpackChunkName: "carvana-purchase-co-signer-identity" */ './co-signer-identity')
);

export const CoSignerIdentityRoute = () => <CoSignerIdentityComponent />;
